import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    AlertModal,
    CCText,
    Modal,
    TouchableOpacity,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import AppConfig from '../../../AppConfig';

import {useSelector} from 'react-redux';
import {BorderlessButton, DarkButton, ThemeButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import ActivityIndicatorWrapper from '../../public/UI/ActivityIndicatorWrapper';
import Styles from '../../../Styles';
import TRestaurantSectionsModal from "./Translations/TRestaurantSectionsModal";

import RestaurantTableItem from "./RestaurantTableItem";
import {useNavigate} from "react-router-dom";
import TableQrCodeModal from "./TableQrCodeModal";
import Select from 'react-select'

import {Collapse} from 'react-collapse';

const RestaurantSectionsModal = (props) => {
    const auth = useSelector(state => state.Auth)
    const id = props.id

    const [loading, setLoading] = useState(true)
    const [addingSection, setAddingSection] = useState(false)
    const [isAddSectionsModalOpen, setIsAddSectionsModalOpen] = useState(false)
    const [sections, setSections] = useState([])
    const [menu, setMenu] = useState({})
    const [menuOptions, setMenuOptions] = useState([]);
    const [changingMenu, setChangingMenu] = useState(false)

    const [form, setForm] = useState({
        controls: {
            RSE_NAME: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TRestaurantSectionsModal[AppConfig.lang].SECTION_NAME
                },
                label: TRestaurantSectionsModal[AppConfig.lang].SECTION_NAME + '*',
                value: '',
                errorMessage: '',
                validation: {
                    required: true,
                    maxLength: 50
                },
                valid: false,
                touched: false,
            },
        },
    })

    const fetchData = async () => {
        setLoading(true);
        const response = await fetch(AppConfig.URL + "/Restaurant/FetchConfigurationData/" + id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            }
        });

        const json = await response.json();

        const menuOptionsCopy = []
        let index = 0;

        for(let i = 0; i < json.menuList.length; i++) {
            menuOptionsCopy.push({
                value: json.menuList[i].meN_ID,
                label: json.menuList[i].meN_NAME
            })

            index = json.menuList[i].meN_ID == json.menu.meN_ID ? i : index;
        }

        setSections(json.sections)
        setMenu(menuOptionsCopy[index])
        setMenuOptions(menuOptionsCopy)

        setLoading(false)
    }

    useEffect(() => {
        if (!props.visible)
            return;

        fetchData()
    }, [props.visible])

    if (loading) {
        return <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
        >
            <ActivityIndicatorWrapper style={{marginTop: 50, marginBottom: 50}}/>
        </Modal>
    }

    return <Modal
        visible={props.visible}
        onRequestClose={props.onRequestClose}
    >
        <View>
            <h4>
                {TRestaurantSectionsModal[AppConfig.lang].MENU}
            </h4>
            <Select
                defaultValue={menu}
                isSearchable={false}
                isLoading={changingMenu}
                options={menuOptions}
                onChange={async (option) => {
                    setChangingMenu(true)
                    try {
                        const response = await fetch(AppConfig.URL + "/Restaurant/ChangeRestaurantMenu/" + id + '?MenuID=' + option.value, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': auth.token
                            }
                        });

                        const json = await response.json();
                    } catch (e) {
                        console.log(e)
                    }

                    setChangingMenu(false)
                }}
            />
        </View>
        <View style={{ marginTop: 25 }}>
            <h4>
                {TRestaurantSectionsModal[AppConfig.lang].RESTAURANT_SECTIONS}
            </h4>
            <CCText style={{textAlign: 'justify'}}>
                {TRestaurantSectionsModal[AppConfig.lang].RESTAURANT_SECTIONS_DESC}
            </CCText>
            {isAddSectionsModalOpen ?
                <div className={'card'} style={{marginTop: 15}}>
                    <div className={'card-body'}>
                        <h4>{TRestaurantSectionsModal[AppConfig.lang].ADD_SECTION}</h4>
                        <ChocoForm
                            form={form}
                            lang={AppConfig.lang}
                            onFormChange={(updatedForm) => {
                                setForm(updatedForm)
                            }}
                        />
                        {addingSection ?
                            <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                <ActivityIndicator size={35}/>
                            </View>
                            :
                            <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                <BorderlessButton
                                    text={TRestaurantSectionsModal[AppConfig.lang].CANCEL}
                                    onPress={() => {
                                        setIsAddSectionsModalOpen(!isAddSectionsModalOpen)
                                    }}
                                />
                                <View style={{width: 7}}></View>
                                <ThemeButton
                                    text={TRestaurantSectionsModal[AppConfig.lang].SAVE}
                                    onPress={async () => {
                                        const controls = {...form.controls}

                                        if (form.isValidForm) {
                                            setAddingSection(true)

                                            const formData = {};

                                            for (let key in controls) {
                                                formData[key] = controls[key].value;
                                            }

                                            formData['RSE_RESTAURANT_ID'] = id;

                                            const response = await fetch(AppConfig.URL + "/Restaurant/CreateRestaurantSection/", {
                                                method: 'POST',
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json',
                                                    'Authorization': auth.token
                                                },
                                                body: JSON.stringify(formData)
                                            });

                                            const json = await response.json();

                                            if (json.success) {
                                                for (let key in controls) {
                                                    controls[key].value = '';
                                                }

                                                let updatedSections = [...sections];

                                                json.restaurantSection.tablesForEditor = [];
                                                json.restaurantSection.collapse = true

                                                updatedSections.push(json.restaurantSection)

                                                setForm({
                                                    controls
                                                })
                                                setAddingSection(false)
                                                setSections(updatedSections);
                                                setIsAddSectionsModalOpen(!isAddSectionsModalOpen)
                                            }
                                        } else {
                                            setIsAddSectionsModalOpen(!isAddSectionsModalOpen)
                                        }
                                    }}
                                />
                            </View>
                        }
                    </div>
                </div>
                :
                <View style={{flexDirection: 'row', justifyContent: 'flex-end', marginTop: 10}}>
                    <ThemeButton
                        text={TRestaurantSectionsModal[AppConfig.lang].NEW_SECTION}
                        onPress={() => setIsAddSectionsModalOpen(!isAddSectionsModalOpen)}
                    />
                </View>
            }
            {sections.map(item => <Section
                key={item.rsE_ID}
                section={item}
            />)}
        </View>
    </Modal>;
}

export default RestaurantSectionsModal;

const Section = (props) => {
    const auth = useSelector(state => state.Auth)
    const navigate = useNavigate();

    const [section, setSection] = useState(props.section)
    const [isQrCodesModalOpen, setIsQrCodesModalOpen] = useState(false)
    const [isAddTablesModalOpen, setIsAddTablesModalOpen] = useState(false)
    const [addingTables, setAddingTables] = useState(false)
    const [deleted, setDeleted] = useState(false)

    const [form, setForm] = useState({
        controls: {
            Quantity: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TRestaurantSectionsModal[AppConfig.lang].QUANTITY,
                    keyboardType: 'numeric'
                },
                label: TRestaurantSectionsModal[AppConfig.lang].QUANTITY + '*',
                value: '',
                errorMessage: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
        }
    });

    const [alertState, setAlertState] = useState({
        alertVisible: false,
        alertTitle: '',
        alertText: '',
        alertButtons: []
    });

    const ToggleAddTablesModal = () => {
        setIsAddTablesModalOpen(!isAddTablesModalOpen)
    }

    const ToggleQrCodesModal = () => {
        setIsQrCodesModalOpen(!isQrCodesModalOpen)
    }

    if(deleted)
        return null;

    return <View
        className="card"
        style={{marginTop: 15,  overflow: 'inherit'}}
    >
        <TouchableOpacity
            onPress={() => {
                const updatedSection = {...section};

                updatedSection.collapse = !updatedSection.collapse;

                setSection(updatedSection)
            }}
        >
            <div className={'card-header'}>
                <View style={{
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row'
                }}>
                    <CCText style={{fontSize: 20, fontWeight: 'bold'}}>
                        {section.rsE_NAME}
                    </CCText>
                    {section.deleting ?
                        <ActivityIndicator/>
                        :
                        <BorderlessButton
                            text={TRestaurantSectionsModal[AppConfig.lang].DELETE}
                            textStyle={{...Styles.redColor}}
                            onPress={() => {
                                setAlertState({
                                    alertVisible: true,
                                    alertTitle: TRestaurantSectionsModal[AppConfig.lang].DELETE_SECTION_TITLE,
                                    alertText: TRestaurantSectionsModal[AppConfig.lang].DELETE_SECTION_TEXT,
                                    alertButtons: [{
                                        text: TRestaurantSectionsModal[AppConfig.lang].CANCEL,
                                        onPress: () => {
                                        },
                                        style: "cancel"
                                    },
                                        {
                                            text: TRestaurantSectionsModal[AppConfig.lang].DELETE,
                                            onPress: async () => {
                                                const response = await fetch(AppConfig.URL + "/Restaurant/DeleteRestaurantSection/" + section.rsE_ID, {
                                                    method: 'GET',
                                                    headers: {
                                                        'Accept': 'application/json',
                                                        'Content-Type': 'application/json',
                                                        'Authorization': auth.token
                                                    }
                                                });

                                                const r = await response.json();

                                                if (r.success) {
                                                    setDeleted(true);
                                                }
                                            }
                                        }]
                                })
                            }}
                        />
                    }
                </View>
            </div>
        </TouchableOpacity>
        <Collapse isOpened={section.collapse}>
            <div className={'card-body'}>
                <View>
                    <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                        <ThemeButton
                            text={TRestaurantSectionsModal[AppConfig.lang].GENERATE_QR_CODES}
                            onPress={ToggleQrCodesModal}
                        />
                        <View style={{width: 7}}></View>
                        <DarkButton
                            text={TRestaurantSectionsModal[AppConfig.lang].ADD_TABLES}
                            onPress={ToggleAddTablesModal}
                        />
                    </View>
                    {isAddTablesModalOpen ?
                        <div className={'card'} style={{marginTop: 15}}>
                            <div className={'card-body'}>
                                <h4>{TRestaurantSectionsModal[AppConfig.lang].ADD_TABLES}</h4>
                                <ChocoForm
                                    form={form}
                                    lang={AppConfig.lang}
                                    onFormChange={(updatedForm) => {
                                        setForm(updatedForm)
                                    }}
                                />
                                {addingTables ?
                                    <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                        <ActivityIndicator size={35}/>
                                    </View>
                                    :
                                    <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                        <BorderlessButton
                                            text={TRestaurantSectionsModal[AppConfig.lang].CANCEL}
                                            onPress={ToggleAddTablesModal}
                                        />
                                        <View style={{width: 7}}></View>
                                        <ThemeButton
                                            text={TRestaurantSectionsModal[AppConfig.lang].SAVE}
                                            onPress={async () => {
                                                const controls = {...form.controls}

                                                if (controls.Quantity.value && controls.Quantity.value > 0) {
                                                    setAddingTables(true)

                                                    const response = await fetch(AppConfig.URL + "/Restaurant/CreateRestaurantTables/" + props.section.rsE_ID + '?Quantity=' + controls.Quantity.value, {
                                                        method: 'GET',
                                                        headers: {
                                                            'Accept': 'application/json',
                                                            'Content-Type': 'application/json',
                                                            'Authorization': auth.token
                                                        },
                                                    });

                                                    const json = await response.json();

                                                    if (json.success) {
                                                        const updatedSection = {...section}
                                                        let updatedTables = [...section.tablesForEditor];

                                                        updatedTables = updatedTables.concat(json.tables)
                                                        updatedSection.tablesForEditor = updatedTables

                                                        setAddingTables(false)
                                                        setSection(updatedSection);
                                                        ToggleAddTablesModal();
                                                    }
                                                } else {
                                                    ToggleAddTablesModal();
                                                }
                                            }}
                                        />
                                    </View>
                                }
                            </div>
                        </div>
                        :
                        null
                    }
                    {section.tablesForEditor.map(table =>
                        <RestaurantTableItem
                            key={table.rtA_ID}
                            item={table}
                            Auth={auth}
                            deleteCallback={() => {
                                const updatedSection = {...section};
                                const updatedTables = [...section.tablesForEditor]
                                const index = updatedTables.findIndex(i => i.rtA_ID == table.rtA_ID);

                                if(index > -1){
                                    updatedTables.splice(index, 1)

                                    updatedSection.tablesForEditor = updatedTables;
                                    setSection(updatedSection);
                                }
                            }}
                        />)}
                    <TableQrCodeModal
                        section={section}
                        tables={section.tablesForEditor}
                        visible={isQrCodesModalOpen}
                        onRequestClose={ToggleQrCodesModal}
                    />
                </View>
            </div>
        </Collapse>
        <AlertModal
            visible={alertState.alertVisible}
            onRequestClose={() => setAlertState({...alertState, alertVisible: !alertState.alertVisible})}
            title={alertState.alertTitle}
            text={alertState.alertText}
            buttons={alertState.alertButtons}
        />
    </View>
}
